import Vue from 'vue'
import Router from 'vue-router'
import WebIndex from '@/pages/web/index'
import PcIndex from '@/pages/pc/index'
import WebProblem from '@/pages/web/problem'
import WebForm from '@/pages/web/form'
import PcForm from '@/pages/pc/form'
import MobBoard from '@/pages/pc/board'
import MobSupplierBoard from '@/pages/pc/supplierBoard'
import WebBoard from '@/pages/web/board'
import WebSupplierBoard from '@/pages/web/supplierBoard'
import WebNews from '@/pages/web/news'
import WebNewsDetail from '@/pages/web/newsDetail'
Vue.use(Router)

export default new Router({
  // mode:'hash',
  routes: [
    {
      path: '/index_web',
      name: 'WebIndex',
      component: WebIndex
    },
    {
      path: '/problem_web',
      name: 'WebProblem',
      component: WebProblem
    },
    {
      path: '/from_web',
      name: 'WebForm',
      component: WebForm
    },
    {
      path: '/index_pc',
      name: 'PcIndex',
      component: PcIndex
    },
    {
      path: '/form_pc',
      name: 'PcForm',
      component: PcForm
    },
    {
      path:"/borad_mob",
      name: 'MobBoard',
      component: MobBoard
    },
    {
      path:"/supplierBorad_mob",
      name: 'MobSupplierBoard',
      component: MobSupplierBoard
    },{
      path:"/supplierBorad_web",
      name: 'WebSupplierBoard',
      component: WebSupplierBoard
    },{
      path:"/borad_web",
      name: 'WebBoard',
      component: WebBoard
    },
    {
      path: '/news_web',
      name: 'WebNews',
      component: WebNews,
      meta: { keepAlive: true }
    },
    {
      path: '/newsDetail_web/:id',
      name: 'WebNewsDetail',
      component: WebNewsDetail,
      // meta: { keepAlive: false }
    }
  ]
})



// WEBPACK FOOTER //
// ./src/router/index.js